import React from "react";
import "../../scss/layout/form.scss";
const BusinessForm = () => {
  return (
    <div className="form-container">
      <h2>Let's do Business!</h2>
      <h4>Company form </h4>

      <form>
        <div className="form-group">
          <input type="text" placeholder="Company Name" className="input-box" />
          <select className="input-box">
            <option>Automotive And Agriculture </option>
            <option>Industry</option>
            <option>Consumer Goods</option>
            <option>Fashion</option>
            <option>Healthcare</option>
            <option>Industrial</option>
            <option>Marine & Cruise</option>
            <option>Renewables</option>
            <option>Perishables</option>
            <option>Technology</option>
            <option>Others</option>
          </select>
        </div>
        <div className="form-group">
          <input type="text" placeholder="STREET" className="input-box" />
          <input type="text" placeholder="ZIP" className="input-box" />
          <input type="text" placeholder="CITY" className="input-box" />
        </div>

        {/* <div className="form-group">
          <select className="input-box">
            <option>Phone Prefix</option>
            <option>+1</option>
            <option>+92</option>
            <option>+44</option>
          </select>
          <input type="text" placeholder="PHONE NUMBER" className="input-box" />
        </div> */}
        {/* <input
          type="email"
          placeholder="E-MAIL ADDRESS"
          className="input-box full-width"
        /> */}
        {/* <div className="buttons">
          <button type="button" className="btn back">
            BACK
          </button>
          <button type="submit" className="btn next">
            NEXT STEP
          </button>
        </div> */}
      </form>
    </div>
  );
};

export default BusinessForm;
